<template>

   <v-alert
      v-motion-slide-right
      :delay="2500"
      border="start"
      close-label="Hinweis schließen"
      color="blue-darken-2"
      title="Hinweis zur Präsentation"
      variant="tonal"
      closable
      class="position-fixed"
      style="top: 100px; right: 16px; z-index: 999; max-width: 450px;"
      clearable
    >
      <div class="text-body-1 text-left mb-2">
        Bitte lade nur Präsentationen hoch, die keine Gliederungsfolien, keine automatischen Layout-Hooks und Overlay-Befehle enthalten.
      </div>

      <div class="d-flex align-left text-h6 text-left mb-1">
        <v-icon size="x-small" color="red-darken-4" class="mr-2 mt-1">mdi-block-helper</v-icon>
        Nicht unterstützte Befehle:
      </div>

    <div class="text-subtitle-2 font-weight-medium mb-1">1. Gliederungs- und Titelfolien</div>

    <div class="text-body-2 text-left mb-1" style="max-width: 450px;">
      Diese Befehle werden aktuell <strong>nur erkannt </strong>, wenn sie sich <strong>innerhalb einer Frame-Umgebung</strong> befinden.
    </div>

    <div class="d-flex flex-wrap align-left ga-2 mb-3 justify-center">
      <v-chip color="red-darken-4" size="small" label><code>\titlepage</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\partpage</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\sectionpage</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\subsectionpage</code></v-chip>
    </div>

    <div class="text-subtitle-2 font-weight-medium mb-1">2. Automatische Folien (Präambel-Hooks)</div>
    <div class="d-flex flex-wrap align-left ga-2 mb-3 justify-center">
      <v-chip color="red-darken-4" size="small" label><code>\AtBeginPart</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\AtBeginSection</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\AtBeginSubsection</code></v-chip>
    </div>

    <div class="text-subtitle-2 font-weight-medium mb-1">3. Overlay- und Animationsbefehle</div>
    <div class="d-flex flex-wrap align-left ga-2 justify-center">
      <v-chip color="red-darken-4" size="small" label><code>\pause</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\onslide</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\only</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\uncover</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\visible</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\invisible</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\alt</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\temporal</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\againframe</code></v-chip>
      <v-chip color="red-darken-4" size="small" label><code>\overlayarea</code></v-chip>
    </div>

      <div class="pt-5 text-left font-weight-bold mb-2">
        Diese Befehle werden aktuell nicht unterstützt und können zu unerwarteten Ergebnissen führen!!
      </div>
    </v-alert>

</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'BeamerUnsupportedFeatures-Componenten',
});
</script>

<style scoped>

</style>